import React from "react";
import { observer } from "mobx-react";
import { PaginatorContainer } from "./Paginator.styled";
import { Pagination } from "@ann/web-components";

const Paginator = observer(({ meta, onPageChange, onItemsPerPageChange }) => {
  if (!meta) {
    return null;
  }

  return (
    <PaginatorContainer>
      <Pagination
        currentPage={meta.currentPage || meta.current_page || 1}
        itemsPerPage={meta.page_size || meta.perPage || meta.per_page || 20}
        totalItems={meta.totalItems || meta.total_items || 0}
        totalPages={meta.totalPages || meta.total_pages || 1}
        onPageChange={onPageChange}
        onItemsPerPageChange={onItemsPerPageChange}
      />
    </PaginatorContainer>
  );
});

export default Paginator;

